// extracted by mini-css-extract-plugin
module.exports = {"flash-messages":"flash-messages__flash-messages___3Hd8r","flash-message-undo-button":"flash-messages__flash-message-undo-button___28JL0"};